import { useTranslation } from 'react-i18next';
import { playClickSound } from '@/utils/soundUtils';
import { Popover, focusRing, cx } from '@/components/ui';
import CampaignOfferPanel from './CampaignOfferPanel';
import { OfferFlame } from './OfferArt';
import { openOffers } from './campaignOfferCopy';
import { useCampaignBonusOffers, useOpenAddMoney } from './CampaignBonusOffersContext';

/** Header chip: flame, "Hot bonus" (wide layouts) and the open-offer count; opens the offer panel. */
export default function CampaignBonusStrip() {
  const { t } = useTranslation();
  const { offers } = useCampaignBonusOffers();
  const openAddMoney = useOpenAddMoney();
  if (offers.length === 0) return null;

  const open = openOffers(offers).length;
  const label = t('campaignBonus.chipAria', 'Deposit bonuses');
  const countLabel = t('campaignBonus.chipCount', { count: open, defaultValue: '{{count}} bonuses open' });

  return (
    <Popover
      aria-label={label}
      align="end"
      width={380}
      scrollable
      trigger={(trigger) => (
        <button
          type="button"
          ref={trigger.ref}
          aria-haspopup={trigger['aria-haspopup']}
          aria-expanded={trigger['aria-expanded']}
          aria-controls={trigger['aria-controls']}
          aria-label={open > 0 ? `${label}, ${countLabel}` : label}
          data-testid="campaign-bonus-strip"
          onClick={() => {
            playClickSound();
            trigger.onClick();
          }}
          className={cx(
            'offer-chip inline-flex h-10 shrink-0 items-center justify-center gap-1.5 px-2.5 @bp-sm:px-3',
            'font-ui text-small font-semibold whitespace-nowrap text-primary',
            focusRing
          )}
        >
          <span className="offer-chip__icon">
            <OfferFlame className="size-5" />
          </span>
          <span className="hidden @bp-sm:inline">{t('campaignBonus.chipLabel', 'Hot bonus')}</span>
          {open > 1 ? (
            <span className="offer-chip__count font-ui text-small font-bold" aria-hidden>
              {open}
            </span>
          ) : null}
        </button>
      )}
    >
      {(close) => (
        <CampaignOfferPanel
          offers={offers}
          onAddMoney={() => {
            close();
            openAddMoney();
          }}
        />
      )}
    </Popover>
  );
}
